import { DynamicAttributeFieldList } from "@/shared/dynamic-attributes/ui/dynamic-attribute-field-list/dynamic-attribute-field-list";
import { FilterContainerWrapper } from "@/shared/filters/ui/containers/with-primary/with-primary-filter";
import { ResetFilterButton } from "./reset-filter-button";
import { useMetaFilterConfig } from "../model/meta-filter-config";
import { useFilterMeta } from "../model/use-filter-meta";

export function AllFilters() {
  const config = useMetaFilterConfig();
  const meta = useFilterMeta();

  return (
    <DynamicAttributeFieldList name="filters" meta={meta}>
      {(meta, { getNameByAttributeCode }) => (
        <FilterContainerWrapper
          primary={
            <>
              {meta.attributes
                .filter((attr) => attr.attributeCode === config?.primary)
                .map((attr) => (
                  <DynamicAttributeFieldList.FormItem
                    key={attr.id}
                    name={getNameByAttributeCode(attr.attributeCode)}
                  >
                    <DynamicAttributeFieldList.ControlProps
                      placeholder={attr.name.value}
                      data-testid="filter-primary-input"
                    >
                      <DynamicAttributeFieldList.Item attributeMeta={attr} />
                    </DynamicAttributeFieldList.ControlProps>
                  </DynamicAttributeFieldList.FormItem>
                ))}
            </>
          }
        >
          <>
            {meta.attributes
              .filter((attr) => attr.attributeCode !== config?.primary)
              .map((attributeMeta) => (
                <DynamicAttributeFieldList.FormItem
                  key={attributeMeta.id}
                  label={attributeMeta.name.value}
                  layout="vertical"
                  name={getNameByAttributeCode(attributeMeta.attributeCode)}
                >
                  <DynamicAttributeFieldList.Item
                    attributeMeta={attributeMeta}
                  />
                </DynamicAttributeFieldList.FormItem>
              ))}
          </>
          <div className="flex justify-end mt-4">
            <ResetFilterButton />
          </div>
        </FilterContainerWrapper>
      )}
    </DynamicAttributeFieldList>
  );
}
